import { defineStore } from "pinia";
import apiClient from "@/core/buildRequest";
import { useI18n } from "vue-i18n";

export const useLeadsStore = defineStore("useLeadsStore", {
  state: () => {
    const { t } = useI18n();
    return {
      leads: [],
      items_per_page: 5,
      current_page: 1,
      total_contacts: 0,
      total_pages: 0,
      hasNextPage: false,
      hasPreviousPage: false,
      commentsList: "",
      sitem: null,
      headers: [
        {
          title: t("marketing_campaign_time"),
          name: "Marketing Campaign Time",
          align: "start",
          sortable: true,
          key: "campaignTime",
        },
        {
          title: t("marketing_campaign"),
          name: "Marketing Campaign",
          align: "start",
          sortable: true,
          key: "marketingCampaign",
        },
        {
          title: t("marketing_source"),
          align: "start",
          sortable: true,
          key: "platform",
        },
        {
          title: t("first_mame"),
          name: "First Name",
          align: "start",
          sortable: true,
          key: "firstName",
        },
        {
          title: t("last_name"),
          name: "Last Name",
          align: "start",
          sortable: true,
          key: "lastName",
        },
        {
          title: t("phone_number"),
          name: "Phone Number",
          align: "start",
          sortable: true,
          key: "phoneNumber",
        },
        {
          title: t("status"),
          name: "Status",
          align: "start",
          sortable: true,
          key: "status",
        },
        {
          title: t("leads_progress"),
          name: "Leads Progress",
          align: "start",
          sortable: true,
          key: "leadsProgressCol",
        },
        {
          title: t("reachability"),
          name: "Reachability",
          align: "start",
          sortable: true,
          key: "reachability",
        },
        {
          title: t("comments"),
          name: "Comments",
          align: "start",
          sortable: false,
          key: "comments",
        },
        {
          title: t("assignee"),
          name: "Assignee",
          align: "start",
          sortable: true,
          key: "assignee",
        },
      ],
      filters: [],
      search: "",
      activities: [],
      totalItems: 0,
    };
  },

  getters: {
    getLeads: (state) => state.leads,
    getHeaders: (state) => state.headers,
    getActivities: (state) => state.activities,
    getTotalItems: (state) => state.totalItems,
  },

  actions: {
    async getAllLeads() {
      try {
        const response = await apiClient.get(`/leads-managment/leads`, {
          params: {
            campaign_name: this.search?.length ? this.search : null,
            filters: this.filters?.length ? this.filters : null,
            per_page: this.items_per_page,
            page: this.current_page,
          },
        });

        const raw = response.data?.data;
        const pagination = raw.pagination;

        if (raw?.data) {
          this.leads = raw.data.map((el) => this.formatLeadData(el));
          this.totalItems = pagination.total_items || pagination.total || 0;
          this.total_pages =
            pagination.total_pages || pagination.last_page || 1;
        } else if (Array.isArray(raw)) {
          this.leads = raw.map((el) => this.formatLeadData(el));
          this.totalItems = raw.length;
          this.total_pages = 1;
        } else {
          this.leads = [];
          this.totalItems = 0;
          this.total_pages = 0;
        }
        console.log("➡️ leads length:", this.leads.length);
      } catch (err) {
        console.error("Error fetching leads:", err);
        this.leads = [];
        this.totalItems = 0;
        this.total_pages = 0;
      }
    },

    formatLeadData(lead) {
      return {
        id: lead.id,
        campaignTime: lead.lead_genration_time,
        marketingCampaign: lead.campaign_name,
        platform: lead.platform,
        firstName: lead.first_name,
        lastName: lead.last_name,
        phoneNumber: lead.phone,
        status: lead.status,
        reachability: lead.reachablitiy,
        leadsProgressCol: "",
        comments: "",
        assignee: lead.assigned_agents,
        touchedStatus: lead.status,
        reachedStatus: lead.progress_status,
        secondReachedStatus: lead.second_progress_status,
        bookedInfo: {
          doctorName: lead.booking?.doctor_name,
          departmentName: lead.booking?.department,
          service: lead.booking?.service,
          consultationDate: lead.booking?.appointment_date,
        },
        attendanceStatus: lead?.attendece_status,
        survey: [],
        activities: [],
        updates: [],
        files: [],
        trails: {
          "1st_trail": lead.call?.["1st_trail"],
          "2nd_trail": lead.call?.["2nd_trail"],
          "3rd_trail": lead.call?.["3rd_trail"],
        },
        haveTrails: !!lead?.call?.id,
        created_at: lead.created_at,
        updated_at: lead.updated_at,
      };
    },

    updateReachabilityStatus(id, val) {
      const index = this.leads.findIndex((item) => item.id === id);
      if (index !== -1) {
        this.leads[index].reachability = val;
      }
    },

    getAllActivities(id) {
      apiClient.get(`/leads-managment/overview/${id}`).then((res) => {
        this.activities = res.data.data;
      });
    },

    onPageChange(val) {
      this.current_page = val;
      this.getAllLeads();
    },

    onItemsPerPageChange() {
      this.current_page = 1;
      this.getAllLeads();
    },
  },
});
